const BASE_URL = 'https://etiskarna.cz';
const DEFAULT_OG_IMAGE = 'https://etiskarna.cz/og-image.jpg';

export const seoData = {
  home: {
    title: 'eTiskarna – Kvalitní tisk Praha | Vizitky, letáky, plakáty',
    description: 'Profesionální tiskárna v Praze. Ofsetový a digitální tisk, vizitky, letáky, plakáty, finishing a kompletace. Kalkulace do 24 hodin.',
    canonical: `${BASE_URL}/`,
    robots: 'index, follow',
    og: {
      title: 'eTiskarna – Kvalitní tisk Praha',
      description: 'Profesionální tiskárna v Praze. Vizitky, letáky, plakáty a 26 dalších produktů. Kalkulace do 24 hodin.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  katalog: {
    title: 'Katalog tiskových produktů – eTiskarna Praha',
    description: 'Letáky, vizitky, plakáty, katalogy, bannery a 26 dalších tiskových produktů. Precizní tisk na míru s dodáním po celé ČR.',
    canonical: `${BASE_URL}/katalog`,
    robots: 'index, follow',
    og: {
      title: 'Katalog tiskových produktů – eTiskarna',
      description: 'Letáky, vizitky, plakáty, katalogy, bannery a 26 dalších tiskových produktů na míru.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  sluzby: {
    title: 'Tiskové služby – Grafika, ofsetový tisk, finishing | eTiskarna Praha',
    description: 'Kompletní tiskové služby: grafika a DTP, ofsetový a digitální tisk, finishing, kompletace zakázek a rozesílání. Tiskárna Praha.',
    canonical: `${BASE_URL}/sluzby`,
    robots: 'index, follow',
    og: {
      title: 'Tiskové služby – eTiskarna Praha',
      description: 'Grafika, DTP, ofsetový a digitální tisk, finishing, kompletace a rozesílání. Kompletní tiskové řešení.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  kontakt: {
    title: 'Kontakt – eTiskarna Praha 15 | Průmyslová 1422/1a',
    description: 'Kontaktujte nás na adrese Průmyslová 1422/1a, Praha 15. Telefon: +420 222 333 444. E-mail: info@etiskarna.cz.',
    canonical: `${BASE_URL}/kontakt`,
    robots: 'index, follow',
    og: {
      title: 'Kontakt – eTiskarna Praha 15',
      description: 'Průmyslová 1422/1a, Praha 15. Telefon: +420 222 333 444. E-mail: info@etiskarna.cz.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  slozky: {
    title: 'Firemní složky a slohy na míru | eTiskarna Praha',
    description: 'Firemní složky a slohy na míru. Formáty A4 a A5, výsek pro vizitku, gramáže do 350g, matná i soft-touch laminace, parciální lak. Tisk na zakázku – eTiskarna Praha.',
    canonical: `${BASE_URL}/slozky`,
    robots: 'index, follow',
    og: {
      title: 'Firemní složky a slohy na míru – eTiskarna Praha',
      description: 'Firemní složky a slohy na míru. Formáty A4 a A5, výsek pro vizitku, prémiové povrchové úpravy.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  katalogy: {
    title: 'Tisk katalogů a brožur na míru | eTiskarna Praha',
    description: 'Katalogy a brožury na míru. Vazby V1, V2 a V4, formáty A4–A5, ofset i digitální tisk, od malých sérií po velké náklady. Kalkulace do 24 hodin – eTiskarna Praha.',
    canonical: `${BASE_URL}/katalogy`,
    robots: 'index, follow',
    og: {
      title: 'Tisk katalogů a brožur na míru – eTiskarna Praha',
      description: 'Katalogy a brožury na míru. Vazby V1, V2 a V4, formáty A4–A5, od malých sérií po velké náklady.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  plakaty: {
    title: 'Tisk plakátů na míru | eTiskarna Praha',
    description: 'Plakáty na míru pro firmy, galerie a akce. Ofset i velkoformátový digitální tisk, formáty A3–XXL, gramáže 120–250g, mat i lesk. Kalkulace do 24 hodin – eTiskarna Praha.',
    canonical: `${BASE_URL}/plakaty`,
    robots: 'index, follow',
    og: {
      title: 'Tisk plakátů na míru – eTiskarna Praha',
      description: 'Plakáty na míru pro firmy, galerie a akce. Ofset i velkoformátový digitální tisk, formáty A3–XXL.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  letaky: {
    title: 'Tisk letáků na míru | eTiskarna Praha',
    description: 'Letáky na míru pro firmy, akce a kampaně. Ofset i digitální tisk, formáty A4–DL, gramáže 90–350g, různé sklady a povrchové úpravy. Kalkulace do 24 hodin – eTiskarna Praha.',
    canonical: `${BASE_URL}/letaky`,
    robots: 'index, follow',
    og: {
      title: 'Tisk letáků na míru – eTiskarna Praha',
      description: 'Letáky na míru pro firmy, akce a kampaně. Ofset i digitální tisk, formáty A4–DL, gramáže 90–350g.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  'reklamni-puzzle': {
    title: 'Reklamní puzzle na míru – firemní dárek | eTiskarna Praha',
    description: 'Reklamní puzzle na míru. Formáty A4, A3, A2, 48–1000 dílků, recyklovaná lepenka 2 mm, ofset s matným lněným lakem, krabice s potiskem v ceně. Od 50 ks. Kalkulace do 24 hodin – eTiskarna Praha.',
    canonical: `${BASE_URL}/reklamni-puzzle`,
    robots: 'index, follow',
    og: {
      title: 'Reklamní puzzle na míru – eTiskarna Praha',
      description: 'Originální firemní dárek. Puzzle s vlastní grafikou, prémiová lepenka 2 mm, matný lněný lak, krabice v ceně.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  'pvc-samolepky': {
    title: 'PVC samolepky na míru – UV tisk, polepy | eTiskarna Praha',
    description: 'PVC samolepky na míru. Monomer, Polymer i Litá fólie pro polepy vozidel. UV tisk, odolnost 3–5 let v exteriéru, libovolné rozměry, tvarový výsek. Kalkulace do 24 hodin – eTiskarna Praha.',
    canonical: `${BASE_URL}/pvc-samolepky`,
    robots: 'index, follow',
    og: {
      title: 'PVC samolepky na míru – eTiskarna Praha',
      description: 'Vinylové samolepky s UV tiskem. Exteriérové, transparentní i pro polepy vozidel. Libovolné tvary a rozměry.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  obalky: {
    title: 'Tisk obálek na míru – C6, DL, C5, C4 | eTiskarna Praha',
    description: 'Tisk obálek na míru. Standardní formáty C6, DL, C5, C4 i zakázkové rozměry. Ofset, horká ražba, slepotisk. Gramáže 90–350 g, FSC papíry. Kalkulace do 24 hodin – eTiskarna Praha.',
    canonical: `${BASE_URL}/obalky`,
    robots: 'index, follow',
    og: {
      title: 'Tisk obálek na míru – eTiskarna Praha',
      description: 'Poštovní i dárkové obálky s potiskem. Ofset, ražba, slepotisk. Všechny standardní formáty i zakázková výroba.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  'lepici-pasky': {
    title: 'Lepící pásky s potiskem na míru | eTiskarna Praha',
    description: 'Potištěné lepicí pásky na míru. Papírové, PVC i BOPP provedení, šířky 25–75 mm, Pantone match. Pro e-shopy i výrobní firmy. Od 12,50 Kč/m. Kalkulace do 24 hodin – eTiskarna Praha.',
    canonical: `${BASE_URL}/lepici-pasky`,
    robots: 'index, follow',
    og: {
      title: 'Lepící pásky s potiskem – eTiskarna Praha',
      description: 'Papírové, PVC a BOPP pásky s logem. Šířky 25–75 mm, Pantone match, ekologické i průmyslové varianty.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  tasky: {
    title: 'Papírové a textilní tašky s potiskem na míru | eTiskarna Praha',
    description: 'Tisk papírových i textilních tašek na míru. Laminace, horká ražba, sítotisk na bavlnu a canvas. Luxusní boutique tašky i ekologické tote bags. Od 250 ks. Kalkulace do 24 hodin – eTiskarna Praha.',
    canonical: `${BASE_URL}/tasky`,
    robots: 'index, follow',
    og: {
      title: 'Papírové a textilní tašky s potiskem – eTiskarna Praha',
      description: 'Papírové tašky s ražbou i bavlněné tote bags se sítotiskem. Prémiová kvalita, vlastní design, od 250 ks.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  knihy: {
    title: 'Tisk knih na míru – V2, V4, V8 vazba | eTiskarna Praha',
    description: 'Tisk knih na míru. Tvrdé desky V8, šitá V4 i PUR lepená V2 vazba. CMYK i černobílý tisk, FSC papíry, laminace, ražba. Od limitovaných edic po velké náklady. Kalkulace do 24 hodin – eTiskarna Praha.',
    canonical: `${BASE_URL}/knihy`,
    robots: 'index, follow',
    og: {
      title: 'Tisk knih na míru – eTiskarna Praha',
      description: 'Prémiová výroba knih. Vazby V2, V4 a V8, PUR lepidlo, prémiové papíry a povrchové úpravy desek.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  bloky: {
    title: 'Tisk reklamních bloků na míru | eTiskarna Praha',
    description: 'Lepené reklamní bloky na míru. Formáty A4, A5, A6, papíry 80–100 g, kraftové i luxusní obálky s UV lakem. 50 nebo 100 listů. Precizní firemní dárek. Kalkulace do 24 hodin – eTiskarna Praha.',
    canonical: `${BASE_URL}/bloky`,
    robots: 'index, follow',
    og: {
      title: 'Tisk reklamních bloků na míru – eTiskarna Praha',
      description: 'Lepené bloky s firemní grafikou. Formáty A4–A6, prémiové papíry, kraftové i luxusní obálky.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  bannery: {
    title: 'Tisk bannerů na míru – velkoplošný UV tisk | eTiskarna Praha',
    description: 'Tisk bannerů na míru. Frontlit, Mesh Airmesh a Blockout materiály, UV tisk odolný 5 let, šířka až 5 m, kovová oka. Pro venkovní reklamu, eventy i fasády budov. Kalkulace do 24 hodin – eTiskarna Praha.',
    canonical: `${BASE_URL}/bannery`,
    robots: 'index, follow',
    og: {
      title: 'Tisk bannerů na míru – eTiskarna Praha',
      description: 'Velkoplošný UV tisk na plachtovinu. Frontlit, Mesh i Blockout, šířka až 5 m, odolnost 5 let venku.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  etikety: {
    title: 'Tisk etiket na míru – role i archy | eTiskarna Praha',
    description: 'Tisk papírových i plastových etiket na míru. Role i archy, digitální výsek do libovolných tvarů, UV lak, fólie a slepotisk. Pro potraviny, kosmetiku i průmysl. Kalkulace do 24 hodin – eTiskarna Praha.',
    canonical: `${BASE_URL}/etikety`,
    robots: 'index, follow',
    og: {
      title: 'Tisk etiket na míru – eTiskarna Praha',
      description: 'Papírové i plastové etikety v rolích a arších. Digitální výsek, prémiové povrchové úpravy, dodávka do 24 hodin.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  obaly: {
    title: 'Tisk obalů na míru – krabičky a krabice | eTiskarna Praha',
    description: 'Tisk obalů na míru pro firmy. Hladká i vlnitá lepenka, digitální výsek bez raznice, UV lak, ražba a slepotisk. Od prototypu po velkou sérii. Kalkulace do 24 hodin – eTiskarna Praha.',
    canonical: `${BASE_URL}/obaly`,
    robots: 'index, follow',
    og: {
      title: 'Tisk obalů na míru – eTiskarna Praha',
      description: 'Hladká i vlnitá lepenka, prémiové povrchové úpravy, konstrukční design na míru. Od malých krabiček po přepravní krabice.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  vizitky: {
    title: 'Vizitky na míru – prémiový tisk, ražba, laminace | eTiskarna Praha',
    description: 'Vizitky na míru. Křídové papíry, nenatírané grafické kartony, G.F Smith a Fedrigoni. Horká ražba, slepotisk, parciální lak, barevná ořízka. Standardní i skládané vizitky se 4 stranami. Kalkulace do 24 hodin – eTiskarna Praha.',
    canonical: `${BASE_URL}/vizitky`,
    robots: 'index, follow',
    og: {
      title: 'Vizitky na míru – eTiskarna Praha',
      description: 'Prémiové vizitky s ražbou, slepotiskem a parciálním lakem. Speciální papíry G.F Smith a Fedrigoni. Od 100 ks.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  vstupenky: {
    title: 'Tisk vstupenek na míru – číslování, perforace, ochranné prvky | eTiskarna Praha',
    description: 'Vstupenky s potiskem na míru. Sekvenční číslování, perforace, UV barvy, hologramy. Formát DL i atypické rozměry, FSC papíry, matné lamino, ražba. Od 100 ks. Kalkulace do 24 hodin – eTiskarna Praha.',
    canonical: `${BASE_URL}/vstupenky`,
    robots: 'index, follow',
    og: {
      title: 'Tisk vstupenek na míru – eTiskarna Praha',
      description: 'Vstupenky s číslováním, perforací a ochrannými prvky. DL i zakázkové formáty, prémiové papíry, dodání po celé ČR.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  'tisk-na-platno': {
    title: 'Tisk na plátno na míru – UV tisk, vlastní obrazy | eTiskarna Praha',
    description: 'Tisk na plátno na míru. 100% bavlna 360 g/m², UV tisk, smrkový rám. Od 20×20 cm po monumentální formáty přes 3 m. Syté barvy odolné vyblednutí. Kalkulace do 24 hodin – eTiskarna Praha.',
    canonical: `${BASE_URL}/tisk-na-platno`,
    robots: 'index, follow',
    og: {
      title: 'Tisk na plátno na míru – eTiskarna Praha',
      description: 'Vlastní obrazy na bavlněném plátně 360 g/m². UV tisk, smrkový rám, libovolný formát. Galerie i domov.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  tapety: {
    title: 'Tapety s vlastním designem na míru – digitální tisk | eTiskarna Praha',
    description: 'Tapety s vlastním potiskem na míru. Vliesové, vinylové i textilní materiály z EU, ekologické barvy, omyvatelný povrch odolný UV. Libovolný rozměr, konzultace zdarma, dodání do 5 dnů. Kalkulace do 24 hodin – eTiskarna Praha.',
    canonical: `${BASE_URL}/tapety`,
    robots: 'index, follow',
    og: {
      title: 'Tapety s vlastním designem – eTiskarna Praha',
      description: 'Zakázkové tapety na míru. Vlies, vinyl, textil, ekologický tisk, libovolný rozměr. Dodání do 5 pracovních dnů.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  'rezana-reklama': {
    title: 'Řezaná reklama na míru – plotrované samolepky | eTiskarna Praha',
    description: 'Řezaná reklama a plotrované samolepky na míru. Fólie Avery Dennison a Oracal, životnost 5–7 let, plotry Graphtec, přenosová fólie připravená k aplikaci. Polepy výloh, aut i fasád. Kalkulace do 24 hodin – eTiskarna Praha.',
    canonical: `${BASE_URL}/rezana-reklama`,
    robots: 'index, follow',
    og: {
      title: 'Řezaná reklama a plotrované samolepky – eTiskarna Praha',
      description: 'Prémiové fólie Avery Dennison a Oracal, životnost 7 let. Polepy výloh, aut, fasád. Kalkulace do 24 hodin.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  'prezentacni-steny': {
    title: 'Prezentační stěny a rollupy na míru – sublimační tisk | eTiskarna Praha',
    description: 'Prezentační stěny a rollupy na míru. Premium Rollup, infostěny 4×2 m i atypické formáty. Sublimační tisk, duralová konstrukce, montáž bez nářadí. Expresní dodání do 48 h. Kalkulace do 24 hodin – eTiskarna Praha.',
    canonical: `${BASE_URL}/prezentacni-steny`,
    robots: 'index, follow',
    og: {
      title: 'Prezentační stěny a rollupy – eTiskarna Praha',
      description: 'Rollupy, infostěny a skládací stěny s sublimačním tiskem. Rychlá montáž, expresní dodání, atypické rozměry.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  'reklamni-desky': {
    title: 'Reklamní desky s potiskem na míru – kapa, PVC sendvič, UV tisk | eTiskarna Praha',
    description: 'Reklamní desky na míru. Kapa desky pro interiér, plastové sendvičové desky pro exteriér, pěněné PVC. Přímý UV tisk odolný vůči vlhkosti a UV záření. Libovolný rozměr. Kalkulace do 24 hodin – eTiskarna Praha.',
    canonical: `${BASE_URL}/reklamni-desky`,
    robots: 'index, follow',
    og: {
      title: 'Reklamní desky s potiskem – eTiskarna Praha',
      description: 'Kapa desky, PVC sendvič i pěněné PVC s UV tiskem. Interiér i exteriér, libovolný rozměr, dodání po celé ČR.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  'pivni-tacky': {
    title: 'Pivní tácky s potiskem na míru – UV tisk | eTiskarna Praha',
    description: 'Pivní tácky s potiskem na míru. Absorpční lepenka Beermat 580 g/m², tloušťka 1,5 mm, kruh Ø 107 mm nebo čtverec 93×93 mm. UV CMYK tisk, odolný vůči vlhkosti. Od 100 ks. Kalkulace do 24 hodin – eTiskarna Praha.',
    canonical: `${BASE_URL}/pivni-tacky`,
    robots: 'index, follow',
    og: {
      title: 'Pivní tácky s potiskem – eTiskarna Praha',
      description: 'Absorpční lepenka 580 g/m², UV CMYK tisk odolný vlhkosti. Kulaté i čtvercové. Od 100 ks, kalkulace do 24 hodin.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  kalendare: {
    title: 'Tisk kalendářů na míru – nástěnné, stolní, plánovací | eTiskarna Praha',
    description: 'Firemní kalendáře na míru. Nástěnné A2–A4 na 250g křídu, stolní týdenní i čtrnáctidenní, plánovací archy. Twin-wire vazba, prémiové papíry Fedrigoni. Kalkulace do 24 hodin – eTiskarna Praha.',
    canonical: `${BASE_URL}/kalendare`,
    robots: 'index, follow',
    og: {
      title: 'Tisk kalendářů na míru – eTiskarna Praha',
      description: 'Nástěnné, stolní i plánovací kalendáře s potiskem. Prémiové papíry, twin-wire vazba, 10bit barevný tisk.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  'samolepici-blocky': {
    title: 'Samolepící bločky s potiskem na míru | eTiskarna Praha',
    description: 'Samolepící bločky s firemním logem na míru. 50×75 mm, 75×75 mm, 100×75 mm i zakázkové rozměry. 80g FSC papír, CMYK tisk 2400 DPI, 50 nebo 100 listů. Od 50 ks. Kalkulace do 24 hodin – eTiskarna Praha.',
    canonical: `${BASE_URL}/samolepici-blocky`,
    robots: 'index, follow',
    og: {
      title: 'Samolepící bločky s potiskem – eTiskarna Praha',
      description: 'Post-it bločky s firemním potiskem. Prémiový FSC papír, CMYK tisk, standardní i zakázkové formáty. Příprava dat zdarma.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  textil: {
    title: 'Textil s potiskem na míru – trika, mikiny, kšiltovky | eTiskarna Praha',
    description: 'Potištěný textil na míru. Trika, mikiny, kšiltovky a ubrusy s firemním logem. Sítotisk, DTF i sublimace. GOTS a OEKO-TEX certifikované materiály. Kalkulace do 24 hodin – eTiskarna Praha.',
    canonical: `${BASE_URL}/textil`,
    robots: 'index, follow',
    og: {
      title: 'Textil s potiskem na míru – eTiskarna Praha',
      description: 'Trika, mikiny, kšiltovky s firemním potiskem. Sítotisk, DTF, sublimace. Ekologické materiály, expresní dodání.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  '3d-napisy': {
    title: '3D plastické nápisy a loga na míru – Zünd G3 frézování | eTiskarna Praha',
    description: 'Plastická 3D písmena a loga frézovaná systémem Zünd G3 3XL. Materiály PVC, Dibond, KAPA, akrylát. Tloušťka 3–19 mm, UV tisk, RAL lakování, montážní šablona. Interiér i exteriér – eTiskarna Praha.',
    canonical: `${BASE_URL}/3d-napisy`,
    robots: 'index, follow',
    og: {
      title: '3D plastické nápisy – eTiskarna Praha',
      description: 'Precizní 3D nápisy a loga. Frézování Zünd G3, PVC, Dibond, akrylát. UV tisk nebo RAL lakování. Dodání po celé ČR.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  vlajky: {
    title: 'Vlajky s potiskem na míru – sublimační tisk, stožáry | eTiskarna Praha',
    description: 'Reklamní vlajky s digitálním sublimačním tiskem. Materiály Supralon a Flag, tvary Muší křídlo, Kapka a obdélníková. Teleskopické stožáry, wide výběr podstavců. UV stabilní, větruodolné, pratelné. Kalkulace do 2 hodin – eTiskarna Praha.',
    canonical: `${BASE_URL}/vlajky`,
    robots: 'index, follow',
    og: {
      title: 'Vlajky s potiskem na míru – eTiskarna Praha',
      description: 'Reklamní vlajky s sublimačním tiskem. Muší křídlo, Kapka, obdélníková. Kompletní sada včetně stožáru a podstavce.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
  poptavka: {
    title: 'Nezávazná poptávka – eTiskarna | Kalkulace do 24 hodin',
    description: 'Poptejte tisk na míru. Vyplňte formulář a náš specialista vás kontaktuje s kalkulací do 24 hodin.',
    canonical: `${BASE_URL}/poptavka`,
    robots: 'noindex, follow',
    og: {
      title: 'Nezávazná poptávka – eTiskarna',
      description: 'Poptejte tisk na míru. Kalkulace do 24 hodin.',
      image: DEFAULT_OG_IMAGE,
      type: 'website',
    },
  },
};
